module.exports = __webpack_public_path__ + "static/img/ls12.05d94c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls12.png
// module id = +W2V
// module chunks = 12